import {IPersistenceStore} from "./ipersistence.store";
import {Injectable} from "@angular/core";

@Injectable()
export class LocalStoragePersistenceStore implements IPersistenceStore {

    getForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string) {
        var value = window.localStorage.getItem(key);
        success(value);
    };

    setForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string, value:string) {
        window.localStorage.setItem(key, value);
        success();
    };

    removeForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string) {
        window.localStorage.removeItem(key);
        success();
    };

}